import { useMutation, useQueryClient } from "@tanstack/react-query";
import { getApiErrorMessage, toApiError } from "../utils";
import api from "../../http";
import { useForBindingId } from '../../../forBinding';
import { CreatePlantAnalysisPayload } from "./types";


export const useUpdatePlantAnalysis = () => {
    const queryClient = useQueryClient();
    const forBinding = useForBindingId();
    return useMutation({
        mutationFn: async ({ id, data }: { id: string; data: CreatePlantAnalysisPayload }) => {
            try {
                return (await api.put(`/plant-analysis/update/${id}`, data, {
                    params: { forBinding },
                })).data;
            } catch (error) {
                throw toApiError(error, 'Erro ao atualizar análise foliar');
            }
        },
        onSuccess: (_, variables) => {
            queryClient.invalidateQueries({ queryKey: ['plantAnalysis'] });
            queryClient.invalidateQueries({ queryKey: ['plantAnalysisId', variables.id] });
        },
        onError: (error) => {
            console.error('Erro ao atualizar análise foliar:', getApiErrorMessage(error, 'Erro ao atualizar análise foliar'))
        },
    });
};
